import React, { useContext } from 'react';

import { RouteComponentProps, useParams } from 'react-router';

import { HouseInfo, WP_HouseMainPage, HouseService } from '../model/models';
import _ from 'underscore';
import HouseCard from '../components/house/houseCard';
import { ServicesTabDesktop } from '../components/house/ServicesTab';
import { NewsTabDesktop } from '../components/house/NewsTab';
import { AboutTabDesktop } from '../components/house/AboutTab';
import { AppPage } from '../AppContent';
import { AppContext } from '../state/AppContextProvider';
import { EventsTabDesktop } from '../components/house/EventsTab';
import { useNewsByHouse } from '../hooks/WPHooks';
import { useEventsByHouse } from '../hooks/EventHook';

interface HouseDashboardProps extends RouteComponentProps {}

const HouseDashboard: React.FC<HouseDashboardProps> = (
  props: HouseDashboardProps
) => {
  const { state } = useContext(AppContext);

  const houseMainPage: WP_HouseMainPage = _.findWhere(state.housePages, {
    parent: 0,
  }) as WP_HouseMainPage;

  const houseServices: HouseService[] = state.housePages.filter(
    (p: HouseInfo) => p.parent && p.parent > 0
  ) as HouseService[];

  const { houseNews } = useNewsByHouse();

  const { houseEvents } = useEventsByHouse();

  const { slug, slug1, slug2 }: any = useParams();

  const slugs: string[] = [slug, slug1, slug2].filter((s) => s);

  return (
    <AppPage>
      <div className="px-14">
        {houseMainPage && <HouseCard houseMainPage={houseMainPage} />}

        <div className="hidden grid-cols-1 gap-10 mt-10 md:grid lg:grid-cols-2">
          <AboutTabDesktop houseMainPage={houseMainPage} />
          <NewsTabDesktop newsList={houseNews} />
          <ServicesTabDesktop
            services={houseServices}
            slugs={slugs}
            houseMainPage={houseMainPage}
          />
          <EventsTabDesktop eventsList={houseEvents.slice(0, 2)} />
        </div>
      </div>
    </AppPage>
  );
};

export default HouseDashboard;
